/* eslint-disable max-len */
import React, {
    useContext, useState, useEffect, useCallback, useMemo
} from 'react';
import { Switch, Route } from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Icon, Chevron, ModalNextProvider
} from '@jutro/components';
import { Table, TableColumn } from '@jutro/datatable';
import { TranslatorContext } from '@jutro/locale';
import { DropdownMenuLink } from '@jutro/router';
import { AppFloorPlan } from '@jutro/floorplan';
import { DynamicRoute, useAuthentication, withAuthContextProvider } from 'gw-digital-auth-react';
import vmTranslator from 'gw-platform-translations';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { AdditionalEnrollment, SignUpEnrollment } from 'gw-capability-enrollment-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-react';
import { filterCapabilityRoutes } from 'gw-portals-config-js';

import { DependencyProvider } from 'gw-portals-dependency-react';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLBIWizard from 'gw-capability-fnol-bi-react';
import FNOLCWWizard from 'gw-capability-fnol-cw-react';
import FNOLELWizard from 'gw-capability-fnol-el-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import SasriaFNOLF1F1TF2Wizard from 'sasria-capability-fnol-f1-f1t-f2-react';
import SasriaFNOLFE3Wizard from 'sasria-capability-fnol-fe3-react';
import SasriaFNOLF4Wizard from 'sasria-capability-fnol-f4-react';
import SasriaFNOLMWizard from 'sasria-capability-fnol-m1-m8-react';
import SasriaFNOLBIWizard from 'sasria-capability-fnol-bi-react';
import SasriaFNOLGITWizard from 'sasria-capability-fnol-git-react';
import SasriaFNOLCWWizard from 'sasria-capability-fnol-cw-react';
import SasriaFNOLMONWizard from 'sasria-capability-fnol-mon-react';
import { EnrollmentService } from 'gw-capability-claimenrollment';
import 'gw-capability-producer-fnol-common-react';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import {
    ClaimList, ClaimDetails, CreateNote, PolicyLevelCoverages
} from 'gw-capability-claim-react';
import { ClaimService } from 'gw-capability-claim';
import { FNOLService, VATServiceEXT } from 'gw-capability-fnol';
// import { SasriaAgentSignupService }  from 'gw-capability-agentsignup-sasria';
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import EntryPage from '../pages/EntryPage/EntryPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import UpdatePasswordPage from '../pages/UpdatePasswordPage/UpdatePasswordPage';
import messages from './App.messages';
import appRoutes from './App.routes.metadata.json5';
import Agentsignup from '../pages/Sasria/Agentsignup/Agentsignup';
import AgentListViewPage from '../pages/Sasria/Agentsignup/AgentListViewPage';
import { SasriaAgentSignupService } from '../../../../common/capabilities/gw-capability-agentsignup-sasria';
import UserSelectionPageAfterDeactivation from '../pages/Sasria/Agentsignup/UserSelectionPageAfterDeactivation';
import SasriaMFAWelcomePage from '../pages/Sasria/MFAWelcomePage/SasriaMFAWelcomePage';

// import Agentsignup from 'sasria-capability-agentsignup-react';

const { capabilitiesConfig, env } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    updatePasswordPage: UpdatePasswordPage,
    additionalenrollmentpage: AdditionalEnrollment,
    basefnolwizard: BaseFNOLWizard,
    claimdetails: ClaimDetails,
    claimlist: ClaimList,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    createnote: CreateNote,
    faqpage: FaqPage,
    fnolbopwizard: FNOLBOPWizard,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    fnolhowizard: FNOLHOWizard,
    fnolpawizard: FNOLPAWizard,
    fnolwcwizard: FNOLWCWizard,
    fnolcwwizard: FNOLCWWizard,
    fnolbiwizard: FNOLBIWizard,
    fnolelwizard: FNOLELWizard,
    sasriafnolf1f1tf2wizard: SasriaFNOLF1F1TF2Wizard,
    sasriafnolfe3wizard: SasriaFNOLFE3Wizard,
    sasriafnolf4wizard: SasriaFNOLF4Wizard,
    sasriafnolmwizard: SasriaFNOLMWizard,
    sasriafnolbiwizard: SasriaFNOLBIWizard,
    sasriafnolgitwizard: SasriaFNOLGITWizard,
    sasriafnolcwwizard: SasriaFNOLCWWizard,
    sasriafnolmonwizard: SasriaFNOLMONWizard,
    policydocumenterror: PolicyDocumentError,
    policylevelcoverages: PolicyLevelCoverages,
    agentsignup: Agentsignup,
    agentListViewPage: AgentListViewPage,
    userSelectionPageAfterDeactivation: UserSelectionPageAfterDeactivation
};
setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...LoginCapabilityComponentMap,
        Chevron: { component: 'Chevron' },
        Icon: { component: 'Icon' },
        Table: { component: 'Table' },
        TableColumn: { component: 'TableColumn' },
        img: { component: 'img' },
        WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
    },
    {
        ...platformComponents,
        ...LoginCapabilityComponents,
        Chevron,
        Icon,
        Table,
        TableColumn,
        img: ImageComponent,
        WizardPageTemplateWithTitle,
    }
);

function App() {
    const auth = useAuthentication();
    const { isAdmin } = useAuthentication();
    // const history = useHistory();
    const translator = useContext(TranslatorContext);
    const [viewModelService, setViewModelService] = useState(undefined);

    // const updatePasswordForUser = useCallback(() => {
    //     return auth.updatePassword(auth.user_name, auth.header)
    //         .then(() => {
    //             history.push('/toUpdatePage');
    //         })
    //         .catch((err) => {
    //             switch (err.error) {
    //                 default:
    //                     history.push('/toUpdatePage');
    //                     break;
    //             }
    //         });
    // }, [auth, history]);


    const getAvatarLinks = useCallback(() => {
        if (isAdmin) {
            return [
                <DropdownMenuLink to="/faq">{translator(messages.faq)}</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-web-portal-disclaimer">Web Portal Disclaimer</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-copyright">Copyright</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-web-portal-privacy-policy">Privacy Policy</DropdownMenuLink>,
                // Commented for MFA R2S-372<DropdownMenuLink onClick={updatePasswordForUser}>{translator(messages.updatePassword)}</DropdownMenuLink>,
                // Commented for MFA R2S-407<DropdownMenuLink to="/agentsignupviewlist">{translator(messages.agentsignup)}</DropdownMenuLink>,
                <DropdownMenuLink onClick={auth.logout}>{translator(messages.logout)}</DropdownMenuLink>
            ];
        // eslint-disable-next-line brace-style
        }
        // eslint-disable-next-line no-else-return
        else {
            return [
                <DropdownMenuLink to="/faq">{translator(messages.faq)}</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-web-portal-disclaimer">Web Portal Disclaimer</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-copyright">Copyright</DropdownMenuLink>,
                <DropdownMenuLink to="/faq#gw-faq-web-portal-privacy-policy">Privacy Policy</DropdownMenuLink>,
                // Commented for MFA R2S-372<DropdownMenuLink onClick={updatePasswordForUser}>{translator(messages.updatePassword)}</DropdownMenuLink>,
                // <DropdownMenuLink  to="/agentsignupviewlist">{translator(messages.agentsignup)}</DropdownMenuLink>,
                <DropdownMenuLink onClick={auth.logout}>{translator(messages.logout)}</DropdownMenuLink>
            ];
        }
    }, [isAdmin, translator, auth.logout]);

    const getLogoSrc = useCallback(() => {
        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
        return `${prefix}/branding/sasria/Sasria_White_Logo.png`;
    }, []);

    // (Router) Title is required and used for (Browser) title
    // in a format of "${title} - ${appName}". In order to show
    // the application name only, it needs to be an empty value.
    const routesWithoutTitle = useMemo(() => {
        return filterCapabilityRoutes(capabilitiesConfig, appRoutes.routes)
            .map((route) => {
                return {
                    ...route,
                    title: ''
                };
            });
    }, []);

    const floorPlansConfig = useMemo(() => {
        return {
            scrollContent: false,
            routes: routesWithoutTitle,
            header: {
                avatarChildren: getAvatarLinks(),
                avatarProps: {
                    username: auth.user_name,
                    title: auth.name,
                    subtitle: auth.user_name
                },
                className: 'appheader',
                logoSrc: getLogoSrc(),
                showAppSwitcher: false,
                showNotifications: false
            },
            footer: {
                componentProps: {
                    fluid: false
                },
                content: [
                    {
                        type: 'element',
                        component: 'FooterCopyright',
                        componentProps: {
                            messageProps: {
                                copyrightMessage: 'Sasria SOC Ltd is an authorised FSP registered under license number 39117'
                            }
                        }
                    }
                    // {
                    //     type: 'container',
                    //     component: 'FooterNavBar',
                    //     content: [
                    //         {
                    //             type: 'action',
                    //             component: 'FooterNavLink',
                    //             componentProps: {
                    //                 header: 'Web Portal Disclaimer',
                    //                 url: '/producer-engage-claims/faq#gw-faq-web-portal-disclaimer'
                    //             }
                    //         },
                    //         {
                    //             type: 'action',
                    //             component: 'FooterNavLink',
                    //             componentProps: {
                    //                 header: 'Copy Right',
                    //                 url: '/producer-engage-claims/faq#gw-faq-copyright'
                    //             }
                    //         },
                    //         {
                    //             type: 'action',
                    //             component: 'FooterNavLink',
                    //             componentProps: {
                    //                 header: 'Privacy Policy',
                    //                 url: '/producer-engage-claims/faq#gw-faq-web-portal-privacy-policy'
                    //             }
                    //         }
                    //     ]
                    // }
                ]
            }
        };
    }, [auth.name, auth.user_name, getAvatarLinks, getLogoSrc, routesWithoutTitle]);


    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
    }, [translator]);

    const handleError = useCallback((error) => {
        if (error) {
            if (error.error === 'checkIfLoggedInError' || error.errorCode === 'GW_ERROR') {
                ModalNextProvider.showAlert({
                    status: 'error',
                    icon: 'mi-error-outline',
                    title: 'Session has expired',
                    message: messages.sessionExpired
                }).then((result) => {
                    if (result === 'confirm') {
                        window.location.reload();
                    }
                }).catch(_.noop);
            } else {
                ModalNextProvider.showAlert({
                    status: 'error',
                    icon: 'mi-error-outline',
                    title: 'An Error',
                    message: error.message,
                }).then((result) => {
                    if (result === 'confirm') {
                        // eslint-disable-next-line no-warning-comments
                        // TODO handle click on confirm
                    }
                }).catch(_.noop);
            }
        }
    }, []);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    EnrollmentService: EnrollmentService,
                    SasriaAgentSignupService: SasriaAgentSignupService,
                    VATServiceEXT: VATServiceEXT
                }}
            >
                <ViewModelServiceContext.Provider value={viewModelService}>
                    <ModalNextProvider />
                    <ErrorBoundary onError={handleError}>
                        <Switch>
                            {/* <Route exact path="/login-page" component={EntryPage} /> */}
                            <Route exact path="/login-page" component={SasriaMFAWelcomePage} />
                            <Route exact path="/auth/resetpassword" component={ResetPasswordPage} />
                            <Route exact path="/signup-enrollment" component={SignUpEnrollment} />
                            <DynamicRoute path="/">
                                <AppFloorPlan
                                    componentMap={componentMap}
                                    {...floorPlansConfig}
                                />
                            </DynamicRoute>
                        </Switch>
                    </ErrorBoundary>
                </ViewModelServiceContext.Provider>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider()(App);
